<template>
	<v-container>
    <LoadingLogo v-if="loadingBaseValue"/>
		<v-form ref="form" v-if="!loadingBaseValue">

			<v-layout row wrap my-2>
				<v-flex md12 sm12 xs12>
					<v-toolbar color="#1f97b9" dark>
						<img :src='require("../../../assets/static/img/clipboard.png")' alt="icono de informacion" style="width: 30px;">
						<v-toolbar-title>COTIZACIÓN RECIBIDA</v-toolbar-title>
					</v-toolbar>
				</v-flex>
			</v-layout>

			<v-layout row wrap my-3 align-center justify-center :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
				<v-flex md4 xs6 px-3 align-center justify-center>
					<h2 class="third-info-title"
						@click="dialogAddress = true">RUTA</h2>
					<GmapMap
						ref="mapDirections"
						class="third-info-map-container"
						v-if="!loadingBaseValue && firstData.direccion_origen"
						:center="firstData.direccion_origen.marker"
						:zoom="15"
						style="width: 100%"
						:options="{
							zoomControl: false,
							mapTypeControl: false,
							scaleControl: false,
							streetViewControl: false,
							rotateControl: false,
							fullscreenControl: false,
							disableDefaultUi: true
						}"
						@click="dialogAddress = true"
					>
						<gmap-polyline
							:options="{'strokeColor': '#1f97b9'}"
							:path="theLatLngs" 
							:editable="false" 
							ref="polygon">
						</gmap-polyline>
						<GmapMarker
							v-if="!loadingBaseValue"
							:position="firstData.direccion_origen.marker" />
						/>
						<GmapMarker
							v-if="!loadingBaseValue"
							:position="firstData.direccion_destino.marker" />
						/>
					</GmapMap>
				</v-flex>
				<v-flex md4 xs6 px-3 class="text-xs-center">
					<h2 class="third-info-title">ITEMS</h2>
					<div class="third-info-container link" @click="dialogElementos = true">
						<p class="font-weight-bold display-4 third-info-qty">{{elementsQty}}</p>
					</div>
				</v-flex>
				<v-flex md4 xs6 px-3 class="text-xs-center">
					<h2 class="third-info-title red--text">SIN AYUDANTES</h2>
					<div class="third-info-container cancel link">
						<img :src='require("../../../assets/static/img/ayudantes.png")' alt="icono de trabajadores DUO">
						<svg style='width: 100%; height: 100%;position: absolute;'>
					    <line x1="0" y1="100%" x2="100%" y2="0"
					        style="stroke:red;stroke-width:4px"/>
					</svg>
					</div>
				</v-flex>
				<v-flex md3 xs6 px-3 class="text-xs-center">
				</v-flex>
			</v-layout>

			<h2 class="text-duo my-5" :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-5': $vuetify.breakpoint.mdAndUp}">RECIBIMOS LA INFORMACION, NOS PONDREMOS EN CONTACTO ANTES DE MEDIA HORA. SI NO LO HACEMOS DESPUES DE 30 MINUTOS PUEDE LLAMARNOS AL +56965909598.</h2>

			<v-dialog
			  v-model="dialogAddress"
			  max-width="600"
			  v-if="allData.first"
			>
			  <v-card>
          <v-toolbar card dark color="#1f97b9">
            <v-toolbar-title>Direcciones Ingresadas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="btn-close-pago-dialog" dark icon @click="dialogAddress = false">
              <v-img :src='require("../../../assets/static/img/cerrar.png")' alt="icono de cierre de ventana" max-height="25" contain></v-img>
            </v-btn>
          </v-toolbar>
			    <v-card-text>
						<v-layout row wrap align-center>
							<v-flex md5 sm6 xs12>
								<v-layout row wrap pa-3 align-center>
									<img :src='require("../../../assets/static/img/direccion-o-d-duo.png")' alt="icono de direcciones" style="width: 25px;margin-right:16px;">
									<h3 class="text-duo">Dirección Origen:</h3>
								</v-layout>
							</v-flex>
							<v-flex md7 sm6 xs12>
								<p class="address-modal-address">{{allData.first.direccion_origen.direccion}}</p>
							</v-flex>
						</v-layout>
						<v-divider class="my-3"></v-divider>
						<v-layout row wrap align-center>
							<v-flex md5 sm6 xs12>
								<v-layout row wrap pa-3 align-center>
									<img :src='require("../../../assets/static/img/direccion-o-d-duo.png")' alt="icono de direcciones" style="width: 25px;margin-right:16px;">
									<h3 class="text-duo">Dirección Destino:</h3>
								</v-layout>
							</v-flex>
							<v-flex md7 sm6 xs12>
								<p class="address-modal-address">{{allData.first.direccion_destino.direccion}}</p>
							</v-flex>
						</v-layout>
			    </v-card-text>
        	<v-layout row wrap justify-center align-center>
        		<v-flex sm12 md12 xs12 justify-center align-center class="text-xs-center">
							<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-3" @click="goBack(2)">
								Deseo Modificarlas
							</v-btn>
						</v-flex>
					</v-layout>
			  </v-card>
			</v-dialog>

			<v-dialog
			  v-model="dialogElementos"
			  max-width="600"
		    v-if="sortedElements.length > 0"
			>
			  <v-card>
          <v-toolbar card dark color="#1f97b9">
            <v-toolbar-title>Artículos Ingresados</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="btn-close-pago-dialog" dark icon @click="dialogElementos = false">
              <v-img :src='require("../../../assets/static/img/cerrar.png")' alt="icono de cierre de ventana" max-height="25" contain></v-img>
            </v-btn>
          </v-toolbar>
			    <v-card-text>

						<v-list two-line class="listado-elementos">
		          <template v-for="(item, index) in sortedElements">
		            <v-list-tile
		              :key="'sf-' + index"
		              class="tile-autoheight"
		            >
		              <v-list-tile-content>
		                <v-list-tile-sub-title>{{ item.cat }}</v-list-tile-sub-title>
		                <v-layout justify-space-between align-center v-for="(el, index1) in sortedElements[index].elements" style="width:100%" my-1>
      								<v-layout row wrap justify-start align-center>
												<v-img
													:src='el.img'
													max-height="40"
													max-width="40"
													class="mr-2"
													contain
												></v-img>
												{{ el.nombre }}
											</v-layout>
											<span>{{el.qty}}</span>
		                </v-layout>
		              </v-list-tile-content>

		            </v-list-tile>
		            <v-divider
		              v-if="index + 1 < allData.second.length"
		              :key="'div-' + index"
		            ></v-divider>
		          </template>
		        </v-list>

			    </v-card-text>
        	<v-layout row wrap justify-center align-center>
        		<v-flex sm12 md12 xs12 justify-center align-center class="text-xs-center">
							<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-3" @click="goBack(3)">
								Deseo Modificarlos
							</v-btn>
						</v-flex>
					</v-layout>
			  </v-card>
			</v-dialog>

			<v-layout row wrap px-3 justify-end align-center mt-3>
				<div>
					<v-btn
						color="grey"
						dark
						@click="goBack(3)"
					>
						Volver
					</v-btn>
				</div>
			</v-layout>
		</v-form>

	</v-container>
</template>

<script>
	import { EventBus } from '../../../events.js'
	import * as firebase from 'firebase/app'
	import LoadingLogo from '../../../helpers/LoadingLogo'
	import 'firebase/functions'
	export default {
		name: 'mudanzaThird',
		components: {LoadingLogo},
		data () {
			return {
				mantenedores: {},
				theLatLngs: [],
				elementsQty: 0,
				terminos: false,
				datos: {
					origen: {},
					destino: {}
				},
				finalValue: 0,
				firstData: {},
				secondData: {},
				sortedElements: [],
				allData: {},
				loadingBaseValue: true,
				loadingFinalValue: false,
				tipo: ['Casa', 'Departamento', 'Local', 'Parcela'],
				rules: {
					control: false,
					required: [
						v => !!v || 'Campo obligatorio'
					],
				},
				dialogAddress: false,
				dialogElementos: false
			}
		},
		methods: {
			goBack(to){
				this.dialogAddress = false
				this.dialogElementos = false
				EventBus.$emit('goBackFlete', to)
			},
			goBottom(){
				document.getElementById("btn-ayudantes").scrollIntoView()
				window.scrollBy(0, -75)
			},
			nextStep(){
				EventBus.$emit('FleteThird');
			},
			tipoOrigenChange(){
				this.datos.origen.piso = this.datos.origen.numero = ''
			},
			tipoDestinoChange(){
				this.datos.destino.piso = this.datos.destino.numero = ''
			},
			validDepto(){
				if( this.datos.origen.tipo == 'Departamento' && this.datos.origen.piso == 0 ){ return false }
				if( this.datos.destino.tipo == 'Departamento' && this.datos.destino.piso == 0 ){ return false }
				return true
			},
			initCalc(){
				this.loadingBaseValue = true
				const baseValue = firebase.functions().httpsCallable('initialCalc')
				this.allData.needDistanceCalc = true

				baseValue({data: this.allData})
				.then(({data}) =>{
					this.allData.baseValue = data
					this.loadingBaseValue = false
					this.getRoute()
					this.countItems()
					this.savePedido()
				})
				.catch(httpsError => {
					this.loadingBaseValue = false
					this.getRoute()
					this.countItems()
				})
			},
			reservaPedido(){
				const data = {
					type: 1,
					from: 3,
					finalDataSave: {
						first: this.firstData,
						second: this.secondData,
						third: this.datos,
						basicoValue: this.allData.baseValue,
						completoValue: 0,
						finalValue: this.allData.baseValue,
						servicio: 'Básico',
						observaciones: this.allData.observaciones
					}
				}
				EventBus.$emit('reservaPedido', data)
			},
			savePedido(){
				let finalData = {
					first: this.firstData,
					second: this.secondData,
					third: this.datos,
					basicoValue: this.allData.baseValue,
					completoValue: 0,
					finalValue: this.allData.baseValue,
					servicio: 'Básico',
					observaciones: this.allData.observaciones
				}
				EventBus.$emit('finalFleteValue', finalData)
			},
			countItems(){
				const here = this
				this.elementsQty = 0
				this.secondData.map(function(element){ 
					here.elementsQty = here.elementsQty + element.qty
				})
			},
			getRoute(){
				this.$gmapApiPromiseLazy().then(() => {
					this.directionsService = new google.maps.DirectionsService()
					this.directionsDisplay = new google.maps.DirectionsRenderer()
					var vm = this
					vm.directionsService.route({
						origin: this.firstData.direccion_origen.direccion,
						destination: this.firstData.direccion_destino.direccion,
						travelMode: 'DRIVING'
					}, function (response, status) {
						vm.theLatLngs = []
						vm.$refs.mapDirections.fitBounds(response.routes[0].bounds)
						response.routes[0].overview_path.map(function(point){ 
							vm.theLatLngs.push({lat: point.lat(), lng: point.lng()})
						})
						if (status === 'OK') {
							vm.directionsDisplay.setDirections(response)
						}
					})
				})

			},
			sortElement(){
				const here = this
				this.sortedElements = []
				this.allData.second.map(function(item) {
					let index = here.sortedElements.findIndex(x => x.cat == item.cat)
					if(index == -1){
						here.sortedElements.push({ cat: item.cat, elements: [] })
						const newIndex = here.sortedElements.length - 1
						here.sortedElements[newIndex].elements.push(item)
					}
					else{
						here.sortedElements[index].elements.push(item)
					}
				});
			}
		},
		mounted(){

			EventBus.$on('fleteFirst', data => {
				this.firstData = data.datos
			})

			EventBus.$on('fleteSecond', data => {
				this.secondData = data.datos
			})

			EventBus.$on('enterFleteThird', data => {
				this.allData = data
				this.sortElement()
				this.initCalc()
			})

			EventBus.$on('emmitMantenedores', data => {
				this.mantenedores = data
				this.loadingBaseValue = false
			})

		}
	}
</script>